import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './ui/button';
import { ArrowRight, Phone } from 'lucide-react';

export const FinalCtaSection = () => {
  const { t, isRTL } = useLanguage();

  const scrollToForm = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-12 sm:py-16 md:py-32 bg-slate-900 text-white" data-testid="final-cta-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 text-center">
        <div className="max-w-3xl mx-auto space-y-6 sm:space-y-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white">
            {t('finalCta.title')}
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-slate-300 leading-relaxed">
            {t('finalCta.description')}
          </p>

          <div className={`flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center ${isRTL ? 'sm:flex-row-reverse' : ''}`}>
            <Button
              onClick={scrollToForm}
              data-testid="final-cta-primary-btn"
              className="h-12 sm:h-14 px-6 sm:px-8 rounded-full bg-brand text-white hover:bg-brand/90 text-base sm:text-lg font-semibold shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 transition-transform duration-300"
            >
              <Phone className={`w-4 h-4 sm:w-5 sm:h-5 ${isRTL ? 'ml-2' : 'mr-2'}`} />
              {t('finalCta.primaryBtn')}
            </Button>
            <Button
              onClick={scrollToForm}
              variant="outline"
              data-testid="final-cta-secondary-btn"
              className="h-12 sm:h-14 px-6 sm:px-8 rounded-full border-2 border-white text-white hover:bg-white/10 text-base sm:text-lg font-semibold transition-colors duration-300"
            >
              {t('finalCta.secondaryBtn')}
              <ArrowRight className={`w-4 h-4 sm:w-5 sm:h-5 ${isRTL ? 'mr-2 rotate-180' : 'ml-2'}`} />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
